import { render, staticRenderFns } from "./user-picker.vue?vue&type=template&id=6b2f8c06&scoped=true&"
import script from "./user-picker.vue?vue&type=script&lang=js&"
export * from "./user-picker.vue?vue&type=script&lang=js&"
import style0 from "./user-picker.vue?vue&type=style&index=0&id=6b2f8c06&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f8c06",
  null
  
)

export default component.exports